// extracted by mini-css-extract-plugin
module.exports = {"careers":"Careers_careers__1g431","placeholder":"Careers_placeholder__3cdJY"};